(function ($, njm) {
    'use strict';

    njm.views.modalSearch = Backbone.View.extend({

        events: {
			"click button": "submit",
			"focus .validated #modal-search": "handleFocusIn",
			"focus .validated button": "handleFocusIn"
		},
		
		initialize: function() {
			
			this.form = this.$("form");
			
			this.formAction = this.form.attr("action");
			
			this.formField = this.$("#modal-search");
			
			this.regexPattern = this.formField.attr("data-val-regex-pattern");
			
			this.regex = new RegExp(this.regexPattern);
		
            this.regexErrorText = this.formField.attr("data-val-regex-error");
			
			this.requiredErrorText = this.formField.attr("data-val-required");
			
			this.errorTooltip = this.$("#searchErrorMsg");
			
			$('body').on('click focusin', this.leaveForm.bind(this));
			
			if (window.location.hash === this.form.attr('data-modal')) {
				var query = this.getQuery();
				
				if (query) {
					this.formField.val(query);
					this.submit();
				}
			}
		},
		
		submit: function() {
			var valid = this.validate(),
				pagePath = window.location.pathname;
			
			if (valid) {
				if (pagePath[pagePath.length - 1] === "/" && pagePath.length > 1) {
					pagePath = pagePath.slice(0,-1);
				}
				
				if (pagePath === this.formAction) {
					this.submitSearch();
				} else if (pagePath != this.formAction) {
					this.redirect();
				}
			}
			
			if (this.formField.val().trim() === '') {
				this.showError();
			}
			
			return false;
		},
		
		redirect: function() {
			
			var site = window.location.origin,
				targetPage = this.formAction,
				query = "?q=" + this.formField.val(),
				modal = this.form.attr('data-modal');
			
			window.location.href = site + targetPage + query + modal;
		},
		
		submitSearch: function() {
			
			var modalName = this.form.attr('data-modal'),
				modal= $(modalName),
				query = this.formField.val();
			
            modal.find('#modal-search-query').val(query);
            modal.find('#SearchQuery').val(query);
            $("#searchModalButton").click();
			njm.views.customModal.prototype.openGenericCustomModal(modalName);
		},
		
		validate: function() {
            var val = this.formField.val(),
            valid = this.regex.test(val);
			
			if (this.formField.val().trim() === '') {
				this.errorTooltip.text(this.requiredErrorText);
				this.form.removeClass('validated');
				return false;
			} else if (!valid) {
				this.errorTooltip.text(this.regexErrorText);
				this.form.addClass('validated');
				this.showError();
			}
			
			return valid;
			
		},
		
		getQuery: function() {
			var search = new URLSearchParams(window.location.search),
				params = Object.fromEntries(search.entries());
			
			return params.q || false;
			
		},
		
		handleFocusIn: function() {
			if (this.formField.val().trim() === '') {
				this.hideError();
			} else {
				this.validate();
			}
		},
		
		hideError: function() {
			this.form.removeClass('haserror');
		},
		
		showError: function() {
			this.form.addClass('haserror');
		},
		
		leaveForm: function(e) {
			if ($(e.target).closest('.comp-modal-search').length === 0) {
				this.hideError();
			}
		}
		
	});
})(jQuery, njm);
